<template>
  <div class="o-ticket-summary">
    <div class="o-ticket-summary__date">{{ date }}</div>
    <div class="o-ticket-summary__body">
      <div class="o-ticket-summary__icon" v-if="icon">
        <o-icon :icon="icon" :keep-colors="true" />
      </div>
      <div class="o-ticket-summary__text">
        <h2 class="o-ticket-summary__label">{{ label }}</h2>
        <div v-if="description" class="o-ticket-summary__description">
          {{ description }}
        </div>
      </div>
      <div v-if="price" class="o-ticket-summary__price">{{ price }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    price: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.o-ticket-summary {
  align-items: center;
  display: flex;

  & + & {
    margin-top: 0.8rem;
  }
}

.o-ticket-summary__date {
  color: $blue-kbc-cement;
  flex: none;
  width: 5.6rem;
}

.o-ticket-summary__body {
  align-items: center;
  background: #fff;
  border-radius: 0.8rem;
  box-shadow: $box-shadow-list;
  display: flex;
  flex: 1 1 0;
  padding: 1.6rem;
}

.o-ticket-summary__icon {
  background-color: #fff;
  border-radius: 50%;
  box-shadow: inset 0 0 0 0.1rem rgba(#000, 0.1);
  color: $primary-color;
  color: var(--primary-color);
  flex: none;
  margin: 0 1.2rem 0 -0.4rem;
  padding: 0.8rem;

  .c-icon {
    display: block;
  }
}

.o-ticket-summary__text {
  flex: 1 1 0;
}

.o-ticket-summary__description {
  color: $blue-kbc-cement;
  font-size: 1.3rem;
  margin-top: 0.4rem;
}

.o-ticket-summary__price {
  margin-left: 0.8rem;
}
</style>
